import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Utymc } from '../entity/Utymc-angular';

@Injectable({
  providedIn: 'root',
})
export class UtymcServicePkg extends JkEntityV2 {
  constructor() {
    super();
    this.linkMasterFields = '';
    this.defaultItem = new Utymc();
    this.entityType.type = EntityType.master;
    this.columnLabel = {
      COMPANY: '公司代號',
      CREATOR: '建檔者代號',
      USR_GROUP: '群組',
      CREATE_DATE: '建檔日期',
      MODIFIER: '修改者代號',
      MODI_DATE: '修改日期',
      FLAG: '更新次數',
      MC001: '編號',
      MC002: '流水號',
      MC003: '外部IP',
      MC004: 'MAC_Address',
      MC005: '備註',
      MC006: '資料',
      MC007: '帳號',
      MC008: '密碼',
      MC009: '內部IP',
      MC010: '類別',
      MC011: '電腦名稱',
      MC012: 'alwaysOn',
      MC013: 'VM主機',
      MC014: '偵測時間',
      MC015: 'isOnline',
      MC016: 'shutdownAPI',
      MC017: 'rebootAPI',
      MC018: 'apiPort',
      MC019: 'platform',
      MC020: 'customId',
      MC021: '上次開機時間',
    };

    this.fieldNames =
      'MC001,MC002,MC003,MC004,MC005,MC006,MC007,MC008,MC009,MC010,MC011,MC012,MC013,MC014,MC015,MC016,MC017,MC018,MC019,MC020,MC021';
    this.fieldLengths = {
      MC001: 15,
      MC002: 6,
      MC003: 15,
      MC004: 17,
      MC005: 255,
      MC006: 2000,
      MC007: 50,
      MC008: 50,
      MC009: 15,
      MC010: 20,
      MC011: 120,
      MC012: 1,
      MC013: 30,
      MC014: 0,
      MC015: 1,
      MC016: 120,
      MC017: 120,
      MC018: 6,
      MC019: 20,
      MC020: 10,
      MC021: 20,
    };
    this.columnDefs = [
      {
        field: 'MC020',
        headerName: 'customId',
        headerTooltip: '',
        width: 150,
        cellDataType: 'text',
      },
      {
        field: 'MC002',
        headerName: '流水號',
        headerTooltip: '',
        width: 118,
        cellDataType: 'text',
      },
      {
        field: 'MC010',
        headerName: '類別',
        headerTooltip: '',
        width: 230,
        cellDataType: 'text',
      },
      {
        field: 'MC004',
        headerName: 'MAC_Address',
        headerTooltip: '',
        width: 206,
        cellDataType: 'text',
      },
      {
        field: 'MC011',
        headerName: '電腦名稱',
        headerTooltip: '',
        width: 250,
        cellDataType: 'text',
        cellRenderer: AgTextAreaEditor,
      },
      {
        field: 'MC006',
        headerName: '資料',
        headerTooltip: '',
        width: 250,
        cellDataType: 'text',
        cellRenderer: AgTextAreaEditor,
      },
      {
        field: 'MC007',
        headerName: '帳號',
        headerTooltip: '',
        width: 250,
        cellDataType: 'text',
      },
      {
        field: 'MC008',
        headerName: '密碼',
        headerTooltip: '',
        width: 250,
        cellDataType: 'text',
      },
      {
        field: 'MC003',
        headerName: '外部IP',
        headerTooltip: '',
        width: 190,
        cellDataType: 'text',
      },
      {
        field: 'MC009',
        headerName: '內部IP',
        headerTooltip: '',
        width: 190,
        cellDataType: 'text',
      },
      {
        field: 'MC005',
        headerName: '備註',
        headerTooltip: '',
        width: 250,
        cellDataType: 'text',
        cellRenderer: AgTextAreaEditor,
      },
      {
        field: 'MC012',
        headerName: 'alwaysOn',
        headerTooltip: '',
        width: 80,
        cellDataType: 'text',
        cellRenderer: AgCheckBoxEditor,
      },
      {
        field: 'MC013',
        headerName: 'VM主機',
        headerTooltip: '',
        width: 250,
        cellDataType: 'text',
      },
      {
        field: 'MC014',
        headerName: '偵測時間',
        headerTooltip: '',
        width: 80,
        cellDataType: 'date',
        valueFormatter: (p: any) => {
          return jkLib.datetimeFormatter(p.value);
        },
      },
      {
        field: 'MC015',
        headerName: 'isOnline',
        headerTooltip: '',
        width: 80,
        cellDataType: 'text',
        cellRenderer: AgCheckBoxEditor,
      },
      {
        field: 'MC016',
        headerName: 'shutdownAPI',
        headerTooltip: '',
        width: 250,
        cellDataType: 'text',
        cellRenderer: AgTextAreaEditor,
      },
      {
        field: 'MC017',
        headerName: 'rebootAPI',
        headerTooltip: '',
        width: 250,
        cellDataType: 'text',
        cellRenderer: AgTextAreaEditor,
      },
      {
        field: 'MC018',
        headerName: 'apiPort',
        headerTooltip: '',
        width: 118,
        cellDataType: 'number',
        cellStyle: { 'text-align': 'right' },
      },
      {
        field: 'MC019',
        headerName: 'platform',
        headerTooltip: '',
        width: 230,
        cellDataType: 'text',
      },
      {
        field: 'MC021',
        headerName: '上次開機時間',
        headerTooltip: '',
        width: 230,
        cellDataType: 'text',
      },
      {
        field: 'MC001',
        headerName: '編號',
        headerTooltip: '',
        width: 190,
        cellDataType: 'text',
      },
    ];
    this.columnDefsVir = [];
    this.tableName = 'UTYMC';
    this.isSys = false;
    this.sqlSelect = `SELECT *  FROM UTYMC`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY MC001,MC002`;
    this.keyFields = ['MC001', 'MC002', 'MC020'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['MC001', 'MC002', 'MC020'];
    this.seqField = '';
    this.seqFieldLength = 4;
  }
  override async validateItem(item: Utymc): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

  override async newRecord(newItem: Utymc): Promise<Utymc> {
    await super.newRecord(newItem);
    return newItem;
  }
}
